module.exports = __webpack_public_path__ + "img/pic7.858ca09c.png";